/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseTillsCashInner
 */
export interface GetConfig200ResponseTillsCashInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTillsCashInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTillsCashInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTillsCashInner
     */
    printerId: string;
}

/**
 * Check if a given object implements the GetConfig200ResponseTillsCashInner interface.
 */
export function instanceOfGetConfig200ResponseTillsCashInner(value: object): value is GetConfig200ResponseTillsCashInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('printerId' in value) || value['printerId'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseTillsCashInnerFromJSON(json: any): GetConfig200ResponseTillsCashInner {
    return GetConfig200ResponseTillsCashInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseTillsCashInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseTillsCashInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'printerId': json['printerId'],
    };
}

export function GetConfig200ResponseTillsCashInnerToJSON(json: any): GetConfig200ResponseTillsCashInner {
    return GetConfig200ResponseTillsCashInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseTillsCashInnerToJSONTyped(value?: GetConfig200ResponseTillsCashInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'printerId': value['printerId'],
    };
}

